// DashboardLayout.jsx - Updated to fix the removeChild error
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../components/Dashboard/Sidebar";
import Navbar from "../components/Dashboard/Navbar";
import { ErrorBoundary } from "../components/Dashboard/ErrorBoundary";

const DashboardLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Ensure component is fully mounted before rendering children
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  const handleSidebarStateChange = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
  };

  // Prevent rendering children until component is fully mounted
  if (!mounted) {
    return null;
  }

  return (
    <div className="h-screen flex flex-col">
      <ToastContainer position="top-right" />

      <div className="flex flex-1 overflow-hidden h-[100%]">
        {/* Sidebar */}
        <ErrorBoundary>
          <Sidebar
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
            onCollapse={handleSidebarStateChange}
          />
        </ErrorBoundary>

        {/* Main content */}
        <div
          className={`flex-1 flex flex-col transition-all duration-300 ${
            isSidebarCollapsed ? "w-[95%] ml-[5%]" : "w-[82%] ml-[18%]"
          }`}
        >
          {/* Navbar */}
          <ErrorBoundary>
            <Navbar
              onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              isSidebarCollapsed={isSidebarCollapsed}
            />
          </ErrorBoundary>

          {/* Dashboard content - Scrollable area */}
          <ErrorBoundary>
            <div className="flex-1 flex flex-col overflow-y-auto bg-[#EEEEEE]">
              {children}
            </div>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
